import { DEFAULT_WORKSPACE_FORMATS, type WorkspaceFormats } from '@eis/core/reporting';

/** The workspace settings document (`workspace_settings.schema.json`, SDD-024 F-1, Q-4). */
export interface SettingsDocument extends WorkspaceFormats {
  readonly schemaVersion: 1;
  readonly kind: 'workspace_settings';
  readonly locale: 'de-DE' | 'en-GB';
  readonly timeZone: string;
  readonly resultReuseMinutes: number;
}

export const DATE_PATTERNS = ['DD.MM.YYYY', 'YYYY-MM-DD', 'DD/MM/YYYY'] as const;
export const DATETIME_PATTERNS = [
  'DD.MM.YYYY HH:mm',
  'YYYY-MM-DD HH:mm',
  'DD.MM.YYYY HH:mm:ss',
] as const;
/** The reuse windows the page offers (minutes; 0 = off, at most a week by the schema). */
export const REUSE_MINUTES = [0, 5, 15, 60, 240, 1440] as const;

/** The document a page edits: the stored one, completed by the defaults a tenant never saved. */
export function settingsDocumentOf(json: Record<string, unknown> | undefined): SettingsDocument {
  const stored = (json ?? {}) as Partial<SettingsDocument>;
  return {
    schemaVersion: 1,
    kind: 'workspace_settings',
    locale: stored.locale ?? 'de-DE',
    timeZone: stored.timeZone ?? 'Europe/Berlin',
    formats: { ...DEFAULT_WORKSPACE_FORMATS.formats, ...(stored.formats ?? {}) },
    resultReuseMinutes: stored.resultReuseMinutes ?? 15,
  };
}
